import React, { useState, useEffect } from "react";
import {
  FilterButton,
  OrderList,
  PartsList,
  OrderItem,
  OrderID,
  ProjectName,
  ButtonContainer,
  TabContainer,
  TabButton,
  ContentContainer,
  ToggleContainer,
  ToggleButton,
  PartItem,
  CountCircle,
  StatusMessage,
  Notifications,
  NotificationsText,
  NotificationsButton,
  PackageList,
  PackageItem,
  LabelSquare,
  PackageStatusMessage,
  PackageLabel,
  SourcingLabel,
  PackageLabelContainer,
  PackageText,
  PackageLabelValue,
  PartName,
} from "./style";
import ConfirmationModal from "../project/ConfirmationModal";
import { Button } from "reactstrap";
import { isMobile, isTablet } from "react-device-detect";
import {
  getParts,
  getPackages,
  packParts,
  deletePackages,
  fetchOrders,
  movePackages,
  deliverPackages,
  unmovePackages,
  dispatchPackages,
} from "./service";
import { Notification } from "../common/style";
import { ProjectButton } from "../project/style";

const Sourcing = () => {
  const [activeFilter, setActiveFilter] = useState("in-progress");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [activeTab, setActiveTab] = useState("parts");
  const [partsView, setPartsView] = useState("all");
  const [packagesView, setPackagesView] = useState("ready");
  const [selectedParts, setSelectedParts] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [parts, setParts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [orders, setOrders] = useState([]);
  const [openShipmentId, setOpenShipmentId] = useState(true);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);

  useEffect(() => {
    fetchAllOrders();
  }, []);

  const fetchAllOrders = () => {
    fetchOrders()
      .then((response) => {
        setOrders(response);
      })
      .catch((error) => console.error("Error fetching orders:", error));
  };

  useEffect(() => {
    if (selectedOrder) {
      loadParts();
      loadPackages();
    }
  }, [selectedOrder]);

  const [packConfirmationOpen, setPackConfirmationOpen] = useState(false);
  const togglePackConfirmation = () => {
    setPackConfirmationOpen(!packConfirmationOpen);
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const [deletePackageConfirmationOpen, setDeletePackageConfirmationOpen] =
    useState(false);
  const toggleDeletePackageConfirmation = () => {
    setDeletePackageConfirmationOpen(!deletePackageConfirmationOpen);
  };

  const [packageActionsConfirmation, setPackageActionsConfirmation] =
    useState(false);
  const togglepackageActionsConfirmation = () => {
    setPackageActionsConfirmation(!packageActionsConfirmation);
  };

  const [dispatchPackagesConfirmation, setDispatchPackagesConfirmation] =
    useState(false);
  const toggleDispatchPackagesConfirmation = () => {
    setDispatchPackagesConfirmation(!dispatchPackagesConfirmation);
  };

  const loadParts = () => {
    getParts(selectedOrder.id)
      .then((response) => {
        setParts(response);
        return response;
      })
      .catch((error) => console.error("Error loading parts:", error));
  };

  const loadPackages = () => {
    getPackages(selectedOrder.id)
      .then((response) => {
        setPackages(response);
        return response;
      })
      .catch((error) => console.error("Error loading packages:", error));
  };

  const handlePartCheckboxChange = (id) => {
    setSelectedParts((prevParts) => {
      const updatedParts = prevParts.includes(id)
        ? prevParts.filter((pkgId) => pkgId !== id)
        : [...prevParts, id];
      return updatedParts;
    });
  };

  const handlePackageCheckboxChange = (id) => {
    setSelectedPackages((prevSelectedPackages) => {
      const updatedSelection = prevSelectedPackages.includes(id)
        ? prevSelectedPackages.filter((pkgId) => pkgId !== id)
        : [...prevSelectedPackages, id];
      return updatedSelection;
    });
  };

  const selectedPartsCount = selectedParts.length;
  const selectedPackagesCount = selectedPackages.length;

  const filteredParts = parts.filter((part) => {
    if (partsView === "all") return true;
    if (partsView === "not_packed") return part.status === "ready";
    if (partsView === "packed") return part.status != "ready";
    return false;
  });

  const filteredPackages = packages.filter((e) => {
    if (packagesView === "ready") return e.status == "packed";
    if (packagesView === "loaded") return e.status == "item_loaded";
    if (packagesView === "in_transit") return e.status == "in_transit";
    if (packagesView === "delivered") return e.status == "delivered";
  });

  useEffect(() => {
    setSelectedParts([]);
    setSelectedPackages([]);
  }, [packagesView, activeTab]);

  useEffect(() => {
    setOpenShipmentId(
      packages.find((e) => e.shipment_id && e.status == "item_loaded")
        ?.shipment_id
    );
  }, [packages]);

  const handlePack = () => {
    packSelection();
    togglePackConfirmation();
  };

  const packSelection = () => {
    packParts(selectedOrder.id, selectedParts)
      .then((response) => {
        const { package_number, parts_packed_count } = response;

        loadParts();
        loadPackages();
        setSelectedParts([]);
        setIsNotificationVisible(true);
        setNotification({
          type: "success",
          message: (
            <>
              Package <strong>#{package_number}</strong> packed with{" "}
              <strong>{parts_packed_count}</strong> parts
            </>
          ),
        });
      })
      .catch((error) => console.error("Error packing selection:", error));
  };

  const handleDeletePackage = () => {
    deleteSelectedPackages();
    toggleDeletePackageConfirmation();
  };

  const deleteSelectedPackages = () => {
    deletePackages(selectedOrder.id, selectedPackages)
      .then(() => {
        loadPackages();
        setSelectedPackages([]);
      })
      .catch((error) => console.error("Error deleting packages:", error));
  };

  const packagesAction = () => {
    packageAction[packagesView](selectedOrder.id, selectedPackages)
      .then((res) => {
        setPackages(res);
        setSelectedPackages([]);
      })
      .catch((error) => console.error("Error deleting packages:", error))
      .finally(() => togglepackageActionsConfirmation());
  };

  const packageAction = {
    ready: movePackages,
    loaded: unmovePackages,
    in_transit: deliverPackages,
  };

  const packageActionInfo = {
    ready: {
      func: () => packagesAction("move"),
      heading: "Load Package",
      message: "load",
      buttonText: "Load",
    },
    loaded: {
      func: () => packagesAction("unmove"),
      heading: "UnLoad Package",
      message: "unload",
      buttonText: "Unload",
    },
    in_transit: {
      func: () => packagesAction("deliver"),
      heading: "Deliver Package",
      message: "mark deliver to",
      buttonText: "Deliver",
    },
  };

  const dispatchSelectedPackages = () => {
    dispatchPackages(selectedOrder.id, openShipmentId)
      .then((res) => {
        setPackages(res);
        setSelectedPackages([]);
      })
      .catch((error) => console.error("Error deleting packages:", error))
      .finally(() => toggleDispatchPackagesConfirmation());
  };

  const getCount = (status) => {
    if (status === "all") return parts.length;
    if (status === "packed")
      return parts.filter((part) => part.status !== "ready").length;
    return parts.filter((part) => part.status === status).length;
  };

  return (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <div className="m-2">
        <h3>Sourcing</h3>
        {!selectedOrder ? (
          <div id="oshow_orders">
            <ButtonContainer className="m-0">
              <FilterButton
                active={activeFilter === "in-progress"}
                // onClick={() => setActiveFilter("in-progress")}
                onClick={fetchAllOrders}
              >
                In Progress
              </FilterButton>
              <FilterButton
                active={activeFilter === "completed"}
                // onClick={() => setActiveFilter("completed")}
                onClick={fetchAllOrders}
              >
                Completed
              </FilterButton>
            </ButtonContainer>
            <OrderList>
              {orders
                // .filter((order) => order.status === activeFilter)
                .map((order) => (
                  <OrderItem
                    key={order.id}
                    onClick={() => setSelectedOrder(order)}
                  >
                    <OrderID>
                      Order ID: {order.internal_id || `#${order.id}`}
                    </OrderID>
                    <ProjectName>{order.projectName}</ProjectName>
                  </OrderItem>
                ))}
            </OrderList>
          </div>
        ) : (
          <div>
            <div>
              <div className="d-flex pointer">
                <i
                  className="fa fa-arrow-left p-2"
                  onClick={() => setSelectedOrder(null)}
                ></i>
                <h4>Order: {selectedOrder.id}</h4>
              </div>
              <TabContainer>
                <TabButton
                  active={activeTab === "parts"}
                  onClick={() => setActiveTab("parts")}
                >
                  Parts
                </TabButton>
                <TabButton
                  active={activeTab === "packages"}
                  onClick={() => setActiveTab("packages")}
                >
                  Packages
                </TabButton>
              </TabContainer>
              <ContentContainer>
                {activeTab === "parts" && (
                  <div>
                    <div
                      className={
                        isMobile
                          ? "d-flex flex-column"
                          : "d-flex flex-row justify-content-between"
                      }
                    >
                      <div className="d-flex justify-content-between">
                        <ToggleContainer>
                          <ToggleButton
                            active={partsView === "all"}
                            onClick={() => setPartsView("all")}
                          >
                            All
                            <CountCircle>{getCount("all")}</CountCircle>
                          </ToggleButton>
                          <ToggleButton
                            active={partsView === "not_packed"}
                            onClick={() => setPartsView("not_packed")}
                          >
                            Not Packed
                            <CountCircle>{getCount("ready")}</CountCircle>
                          </ToggleButton>
                          <ToggleButton
                            active={partsView === "packed"}
                            onClick={() => setPartsView("packed")}
                          >
                            Packed
                            <CountCircle>{getCount("packed")}</CountCircle>
                          </ToggleButton>
                        </ToggleContainer>
                      </div>
                    </div>

                    <PartsList selectedPartsCount={selectedPartsCount}>
                      {filteredParts.length === 0 ? (
                        <div className="d-flex justify-content-center align-item-center">
                          <h6
                            style={{
                              height: "150px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "gray",
                            }}
                          >
                            No parts available
                          </h6>
                        </div>
                      ) : (
                        filteredParts.map((part) => (
                          <PartItem key={part.id} partType={part.type}>
                            {part.status == "ready" && (
                              <input
                                type="checkbox"
                                checked={selectedParts.includes(part.id)}
                                onChange={() =>
                                  handlePartCheckboxChange(part.id)
                                }
                              />
                            )}
                            <SourcingLabel>{part.label}</SourcingLabel>
                            <PartName
                              style={{
                                fontSize: `${
                                  isMobile ? "5px" : isTablet ? "14px" : "20px"
                                }`,
                              }}
                            >
                              {part.name}
                            </PartName>
                            <StatusMessage packed={part.status !== "ready"}>
                              {part.status !== "ready" ? (
                                <>
                                  <i
                                    className="fa-solid fa-circle-check"
                                    style={{
                                      color: "#1a7520",
                                      marginRight: "10px",
                                      fontSize: `${
                                        isMobile
                                          ? "15px"
                                          : isTablet
                                            ? "20px"
                                            : "20px"
                                      }`,
                                    }}
                                  ></i>
                                  <span className="text-capitalize">
                                    {part.status === "packed" ? (
                                      <>
                                        {part.package_number &&
                                          ` Package  #${part.package_number}`}{" "}
                                      </>
                                    ) : (
                                      part.status
                                    )}
                                  </span>
                                </>
                              ) : (
                                "Not Packed"
                              )}
                            </StatusMessage>
                          </PartItem>
                        ))
                      )}
                    </PartsList>
                    {selectedPartsCount > 0 && (
                      <Notifications>
                        <NotificationsText>
                          {selectedPartsCount} part
                          {selectedPartsCount > 1 ? "s" : ""} selected
                        </NotificationsText>

                        <NotificationsButton
                          onClick={togglePackConfirmation}
                          className="rounded-1 m-3"
                        >
                          Pack
                        </NotificationsButton>
                        <Button
                          onClick={() => setSelectedParts([])}
                          className="rounded-1"
                          outline
                        >
                          Cancel
                        </Button>
                      </Notifications>
                    )}
                  </div>
                )}
                {activeTab === "packages" && (
                  <div>
                    <div className="d-flex justify-content-between">
                      <ToggleContainer className="m-0">
                        <ToggleButton
                          active={packagesView === "ready"}
                          onClick={() => setPackagesView("ready")}
                        >
                          Ready
                          <CountCircle>
                            {
                              packages.filter((e) => e.status == "packed")
                                .length
                            }
                          </CountCircle>
                        </ToggleButton>
                        <ToggleButton
                          active={packagesView === "loaded"}
                          onClick={() => setPackagesView("loaded")}
                        >
                          Loaded
                          <CountCircle>
                            {
                              packages.filter((e) => e.status == "item_loaded")
                                .length
                            }
                          </CountCircle>
                        </ToggleButton>
                        <ToggleButton
                          active={packagesView === "in_transit"}
                          onClick={() => setPackagesView("in_transit")}
                        >
                          In-Transit
                          <CountCircle>
                            {
                              packages.filter((e) => e.status == "in_transit")
                                .length
                            }
                          </CountCircle>
                        </ToggleButton>
                        <ToggleButton
                          active={packagesView === "delivered"}
                          onClick={() => setPackagesView("delivered")}
                        >
                          Delivered
                          <CountCircle>
                            {
                              packages.filter((e) => e.status == "delivered")
                                .length
                            }
                          </CountCircle>
                        </ToggleButton>
                      </ToggleContainer>
                      <ProjectButton
                        disabled={!openShipmentId}
                        className="fs-6"
                        onClick={toggleDispatchPackagesConfirmation}
                      >
                        Start Shipping
                        <i className="fa-solid fa-truck-fast fs-6 ms-2"></i>
                      </ProjectButton>
                    </div>

                    <PackageList>
                      {filteredPackages.length === 0 ? (
                        <div className="d-flex justify-content-center align-item-center">
                          <h6
                            style={{
                              height: "150px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "gray",
                            }}
                          >
                            No packages available
                          </h6>
                        </div>
                      ) : (
                        filteredPackages.map((pkg) => (
                          <PackageItem key={pkg.id}>
                            {pkg.status != "delivered" && (
                              <input
                                type="checkbox"
                                checked={selectedPackages.includes(pkg.id)}
                                onChange={() =>
                                  handlePackageCheckboxChange(pkg.id)
                                }
                              />
                            )}
                            {pkg.shipment_identifier && (
                              <PackageLabelContainer>
                                <PackageText>Shipment#</PackageText>
                                <PackageLabelValue>
                                  {pkg.shipment_identifier}
                                </PackageLabelValue>
                              </PackageLabelContainer>
                            )}
                            <PackageLabelContainer>
                              <PackageText>Package#</PackageText>
                              <PackageLabelValue>
                                {pkg.package_number}
                              </PackageLabelValue>
                            </PackageLabelContainer>{" "}
                            <PackageStatusMessage>
                              <span>Parts:</span>
                              {pkg.order_parts.map((part, idx) => (
                                <LabelSquare key={idx}>
                                  {part.label}
                                </LabelSquare>
                              ))}
                            </PackageStatusMessage>
                          </PackageItem>
                        ))
                      )}
                    </PackageList>
                    {selectedPackagesCount > 0 && (
                      <Notifications>
                        <NotificationsText>
                          {selectedPackagesCount} package
                          {selectedPackagesCount > 1 ? "s" : ""} selected
                        </NotificationsText>
                        <NotificationsButton
                          onClick={togglepackageActionsConfirmation}
                          disabled={selectedPackagesCount === 0}
                          className="rounded-1 m-3"
                        >
                          {packageActionInfo[packagesView].buttonText}
                        </NotificationsButton>
                        <Button onClick={() => setSelectedPackages([])}>
                          Cancel
                        </Button>
                        {packagesView == "ready" && (
                          <icon
                            onClick={toggleDeletePackageConfirmation}
                            className="fa-regular fa-trash-can fs-5 ms-3 pointer"
                          />
                        )}
                      </Notifications>
                    )}
                  </div>
                )}
              </ContentContainer>
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        isOpen={packConfirmationOpen}
        toggle={togglePackConfirmation}
        onConfirm={handlePack}
        headingText="Pack Confirmation"
        message={`Are you sure you want to pack ${selectedPartsCount} part${
          selectedPartsCount > 1 ? "s" : ""
        }?`}
      />
      <ConfirmationModal
        isOpen={deletePackageConfirmationOpen}
        toggle={toggleDeletePackageConfirmation}
        onConfirm={handleDeletePackage}
        headingText="Delete Confirmation"
        message={`Are you sure you want to delete ${selectedPackagesCount} package${
          selectedPackagesCount > 1 ? "s" : ""
        }?`}
      />
      <ConfirmationModal
        isOpen={packageActionsConfirmation}
        toggle={togglepackageActionsConfirmation}
        onConfirm={packageActionInfo[packagesView]?.func}
        headingText={packageActionInfo[packagesView]?.heading}
        message={`Are you sure you want to ${
          packageActionInfo[packagesView]?.message
        } ${selectedPackagesCount} package${
          selectedPackagesCount > 1 ? "s" : ""
        }?`}
      />
      <ConfirmationModal
        isOpen={dispatchPackagesConfirmation}
        toggle={toggleDispatchPackagesConfirmation}
        onConfirm={dispatchSelectedPackages}
        headingText="Dispatch Packages"
        message="Are you sure you want to dispatch packages"
      />
    </>
  );
};

export default Sourcing;
